import React, { useContext } from 'react';

// Components
import { WpIcon } from 'Wpds/components/icon';
import { WpLink } from 'Wpds/components/link';
import { WpPopover, WpPopoverContent, WpPopoverToggle } from 'Wpds/components/popover';
import { WpText } from 'Wpds/components/text';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useOrganization } from 'Shared/utils/hooks/use-organization';

// Context
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';

// Styles
import './ThirdPartyUserIndicator.scss';

/**
 * A component which contains the link to PI from PI Perform built for the
 * SideNavigation component.
 */
const ThirdPartyUserIndicator = () => {
  const isExpanded = useContext(ExpandNavbarContext);
  const { piAppUrl } = useApp();
  const { isThirdPartyUser: currentUserIsThirdParty } = useCurrentUser();
  const { organization } = useOrganization();

  if (!isExpanded) return null;
  if (!currentUserIsThirdParty) return null;

  const baseClassName = 'ThirdPartyUserIndicator';

  return (
    <WpPopover placement="right-start" event="hover" maxWidth="300px">
      <WpPopoverToggle>
        <div className={baseClassName}>
          <div className={`${baseClassName}__header`}>
            <WpText noMargin bold={true}>
              Company:
            </WpText>
            <WpLink href={piAppUrl} target="_self" className={`${baseClassName}__header__link`}>
              <WpIcon name="external-link" size="sm" />
              Switch
            </WpLink>
          </div>
          <WpText noMargin>{organization.name}</WpText>
        </div>
      </WpPopoverToggle>
      <WpPopoverContent>
        <WpText bold>To switch companies:</WpText>
        <WpText noMargin>Select a different company from the dropdown menu in the Predictive Index platform.</WpText>
      </WpPopoverContent>
    </WpPopover>
  );
};

export default React.memo(ThirdPartyUserIndicator);
